import { FloatingButtonConfig } from '@fb/models';

/** Web components may pass `config` as JSON string or object — normalize to a typed object. */
export function parseFloatingButtonConfig(
  config: FloatingButtonConfig | string,
): FloatingButtonConfig {
  if (typeof config === 'string') {
    try {
      return JSON.parse(config) as FloatingButtonConfig;
    } catch (e) {
      console.error('Invalid JSON string in config.currentValue', e);

      return {} as FloatingButtonConfig;
    }
  }

  return config;
}
